{
    let header = document.querySelector('.header');

    if (header !== null) {
        let observer = new ResizeObserver(([e]) => {
            let new_height = e.target.getBoundingClientRect().height;
            document.querySelector('html').style.setProperty('--scroll-padding', `${new_height}px`);
        });

        observer.observe(header);
    }
}
